
                import "css-modules://src_components_navigation_menu"
                export default {"Main":"_10228e","Open":"_973588","Close":"_126f2d","Inner":"_903295","Primary":"_a4960a","Secondary":"_e3b9c8","Date":"_bae95a","DateDesktop":"_444503","Item":"_4e347f","Active":"_9379fc","Bottom":"_81a874"}
            